var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-surface-secondary w-100" }, [
    _c("header", { staticClass: "bg-surface-primary border-bottom" }, [
      _c("div", { staticClass: "container-fluid py-4" }, [
        _c("div", { staticClass: "row align-items-center" }, [
          _c("div", { staticClass: "col" }, [
            _c("div", { staticClass: "d-flex align-items-center gap-4" }, [
              _c("div", [
                _c("button", {
                  staticClass: "btn-close text-xs",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                }),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "vr opacity-20 my-1" }),
              _vm._v(" "),
              _c("h1", { staticClass: "h4 ls-tight" }, [
                _vm._v("Crear nuevo paquete"),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-auto" }, [
            _c("div", { staticClass: "hstack gap-2 justify-content-end" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-h btn-success px-3",
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.CREATE()
                    },
                  },
                },
                [
                  _vm.count == 1
                    ? _c(
                        "div",
                        {
                          staticClass: "spinner-border spinner-border-sm",
                          attrs: { role: "status" },
                        },
                        [
                          _c("span", { staticClass: "sr-only" }, [
                            _vm._v("Loading..."),
                          ]),
                        ]
                      )
                    : _c("span", [_vm._v("Guardar")]),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("main", { staticClass: "py-6 bg-surface-secondary" }, [
      _c("div", { staticClass: "container-fluid vstack gap-5" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-6" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Tracking")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.tracking,
                        expression: "data.tracking",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.tracking ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.tracking },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "tracking", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._l(_vm.errors.tracking, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Transportista"),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.carrier_id ? "is-invalid" : "",
                  attrs: {
                    items: _vm.carriers,
                    "item-text": "name",
                    "item-value": "id",
                    "hide-details": "",
                    "no-data": "",
                  },
                  model: {
                    value: _vm.data.carrier_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "carrier_id", $$v)
                    },
                    expression: "data.carrier_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.carrier_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Descripción"),
                ]),
                _vm._v(" "),
                _c("v-combobox", {
                  staticClass: "form-control form-control-sm textarea",
                  class: _vm.errors.description ? "is-invalid" : "",
                  attrs: {
                    chips: "",
                    "hide-details": "",
                    multiple: "",
                    "append-icon": "",
                    clearable: "",
                    delimiters: [","],
                  },
                  on: { "click:append": function ($event) {} },
                  scopedSlots: _vm._u([
                    {
                      key: "selection",
                      fn: function (ref) {
                        var attrs = ref.attrs
                        var item = ref.item
                        var select = ref.select
                        var selected = ref.selected
                        return [
                          _c(
                            "v-chip",
                            _vm._b(
                              {
                                attrs: {
                                  small: "",
                                  close: "",
                                  "input-value": selected,
                                },
                                on: {
                                  "click:close": function ($event) {
                                    return _vm.REMOVE(item)
                                  },
                                },
                              },
                              "v-chip",
                              attrs,
                              false
                            ),
                            [
                              _c("div", { staticClass: "nowrap" }, [
                                _vm._v(_vm._s(item)),
                              ]),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                  model: {
                    value: _vm.data.description,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "description", $$v)
                    },
                    expression: "data.description",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.description, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Cliente"),
                ]),
                _vm._v(" "),
                _c("search-user", {
                  attrs: { childclass: _vm.errors.user_id ? "is-invalid" : "" },
                  on: {
                    set_value: function (e) {
                      return (_vm.data.user_id = e)
                    },
                  },
                  model: {
                    value: _vm.data.user,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "user", $$v)
                    },
                    expression: "data.user",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.user_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Remitente (tienda)"),
                ]),
                _vm._v(" "),
                _c("search-shipper", {
                  attrs: { childclass: _vm.errors.shipper ? "is-invalid" : "" },
                  model: {
                    value: _vm.data.shipper,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "shipper", $$v)
                    },
                    expression: "data.shipper",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.shipper, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Largo")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.lengthy,
                        expression: "data.lengthy",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.lengthy ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.lengthy },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "lengthy", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _vm._l(_vm.errors.lengthy, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Ancho")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.width,
                        expression: "data.width",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.width ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.width },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "width", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(2),
                  _vm._v(" "),
                  _vm._l(_vm.errors.width, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Alto")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.tall,
                        expression: "data.tall",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.tall ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.tall },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "tall", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(3),
                  _vm._v(" "),
                  _vm._l(_vm.errors.tall, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [
                _vm._v("Peso Volumétrico"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.volumetric_weight,
                        expression: "data.volumetric_weight",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.volumetric_weight ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.volumetric_weight },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(
                          _vm.data,
                          "volumetric_weight",
                          $event.target.value
                        )
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(4),
                  _vm._v(" "),
                  _vm._l(_vm.errors.volumetric_weight, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-3" }, [
            _c("div", { staticClass: "form-group mb-2" }, [
              _c("small", { staticClass: "input-title" }, [_vm._v("Peso")]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "input-group input-group-sm" },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.data.weight,
                        expression: "data.weight",
                      },
                    ],
                    staticClass: "form-control form-control-sm",
                    class: _vm.errors.weight ? "is-invalid" : "",
                    attrs: { type: "text" },
                    domProps: { value: _vm.data.weight },
                    on: {
                      keypress: _vm.DOUBLE,
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.data, "weight", $event.target.value)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _vm._m(5),
                  _vm._v(" "),
                  _vm._l(_vm.errors.weight, function (error, index) {
                    return _c(
                      "small",
                      { key: index, staticClass: "invalid-feedback" },
                      [_vm._v(_vm._s(error))]
                    )
                  }),
                ],
                2
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [_vm._v("Piezas")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.data.pieces,
                      expression: "data.pieces",
                    },
                  ],
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.pieces ? "is-invalid" : "",
                  attrs: { type: "text" },
                  domProps: { value: _vm.data.pieces },
                  on: {
                    keypress: _vm.NUMBER,
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.data, "pieces", $event.target.value)
                    },
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.pieces, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Embalaje"),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.packing_id ? "is-invalid" : "",
                  attrs: {
                    items: _vm.packings,
                    "item-text": "name",
                    "item-value": "id",
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.data.packing_id,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "packing_id", $$v)
                    },
                    expression: "data.packing_id",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.packing_id, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-6" }, [
            _c(
              "div",
              { staticClass: "form-group mb-2" },
              [
                _c("small", { staticClass: "input-title" }, [
                  _vm._v("Acción Requerida"),
                ]),
                _vm._v(" "),
                _c("v-select", {
                  staticClass: "form-control form-control-sm",
                  class: _vm.errors.action ? "is-invalid" : "",
                  attrs: { items: _vm.actions, "hide-details": "" },
                  model: {
                    value: _vm.data.action,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "action", $$v)
                    },
                    expression: "data.action",
                  },
                }),
                _vm._v(" "),
                _vm._l(_vm.errors.action, function (error, index) {
                  return _c(
                    "small",
                    { key: index, staticClass: "invalid-feedback" },
                    [_vm._v(_vm._s(error))]
                  )
                }),
              ],
              2
            ),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-prepend" }, [
      _c("span", { staticClass: "input-group-text" }, [
        _vm._v(
          "\n                                    #\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v(
          "\n                                    in\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v(
          "\n                                    in\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v(
          "\n                                    in\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v(
          "\n                                    lbs\n                                "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "input-group-append" }, [
      _c("span", { staticClass: "input-group-text bg-white" }, [
        _vm._v(
          "\n                                    lbs\n                                "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }